module.exports = __webpack_public_path__ + "img/choose-gift-friday.363fcd9c.webp";